import { render, staticRenderFns } from "./Principal.vue?vue&type=template&id=55fccbc4&scoped=true&"
import script from "./Principal.vue?vue&type=script&lang=js&"
export * from "./Principal.vue?vue&type=script&lang=js&"
import style0 from "./Principal.vue?vue&type=style&index=0&id=55fccbc4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fccbc4",
  null
  
)

export default component.exports